import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setFirstStep, setParamsMus, setTitularData } from '../redux/reducer/stepReducer/stepReducer';
import { saveMenu } from '../redux/reducer/stepReducer/thunks';
import { CODEMP_MUSIMUNDO, COMPANY_BBVA } from '../utilities';
import { Stack } from '@mui/material';



export default function MuiCard(props) {
    const { title, description, caption, codsec, codcia, image, logo, size, fecpro } = props
    const { codemp } = useSelector(state => state.adminReducer.login);
    const { firstStep, titularData, paramsMus, codpmpol } = useSelector((state) => state.firstStep);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleCardClick = async () => {
        if (firstStep.codcia !== '' && firstStep.codcia !== codcia) {
            // Compañía es distinta
            dispatch(setTitularData({ province: '', city: '' }));
            if (firstStep.codcia === COMPANY_BBVA && titularData.numAddress !== '') {
                dispatch(setTitularData({ address: titularData.address + ' ' + titularData.numAddress }));
            }
            if (codcia === COMPANY_BBVA && titularData.address !== '') {
                const numExist = titularData.address.match(/\d+/);
                if (numExist) {
                    if (numExist['index'] === 0) {
                        dispatch(setTitularData({ address: '', numAddress: '' }));
                        return;
                    }
                    else dispatch(setTitularData({ address: titularData.address.substring(0, numExist['index'] - 1), numAddress: numExist[0] }))
                };
            };
        };
        dispatch(setFirstStep({ title, codsec, codcia, fecpro }));
        if (codsec !== firstStep.codsec) await dispatch(saveMenu({ codsec, codcia, title, ...paramsMus }, codemp));
        // localStorage.setItem("plan", JSON.stringify({ codsec, codcia, title, ...paramsMus }));
        localStorage.setItem("firstStep", JSON.stringify({ codsec, codcia, title, fecpro, ...paramsMus }));
        localStorage.setItem("productType", JSON.stringify(String(codsec)));
        navigate('/elegirPlan');
    };

    return (
        <Card sx={{
            maxWidth: 328,
            minWidth: 200,
            width: 320,
            height: 325,
            borderRadius: '8px',
            marginBottom: '12px',
            marginRight: '4px',
            marginLeft: '4px',
        }} onClick={handleCardClick} style={{ cursor: 'pointer' }}>
            <CardMedia
                sx={{ width: 320, height: 160 }}
                image={image}
            />
            <CardContent sx={{ width: 328, height: 169 }}>
                <Stack display={'flex'} justifyContent={'space-between'} flexDirection={'row'}>
                    <Typography gutterBottom variant="h5" component="div" style={{ fontFamily: 'Roboto', fontWeight: '600' }} sx={{ fontSize: '1rem' }} >
                        {title}
                    </Typography>
                    <img src={logo} alt='logo' style={{ width: size }} />
                </Stack>
                <Typography
                    gutterBottom
                    variant="h8"
                    component="div"
                    sx={{ marginBottom: '25px' }}
                    style={{ fontFamily: 'Roboto', fontSize: '0.9rem' }}
                    className={CODEMP_MUSIMUNDO.includes(codemp) ? 'mus-strong' : 'cfn-strong'}>
                    <strong>{caption}</strong>
                </Typography>
                <Typography variant="body2" color="text.secondary" style={{ fontFamily: 'Roboto', fontSize: '0.9 rem', marginTop: '35px' }}>
                    {description}
                </Typography>
            </CardContent>
        </Card>
    );
}